import authInstance from "../Interceptor/interceptor";

export const addDoctorEffect = (doctorData) => {
  return authInstance.post("/doctor/insert", doctorData);
};

export const deleteDoctorEffect = (id) => {
  return authInstance.delete(`/doctor/deletedoctor/${id}`);
};
export const editDoctorEffect = (id, formData) => {
  return authInstance.put(`/doctor/updatedoctor/${id}`, formData);
};
export const ViewDoctorEffect = (doctorId) => {
  return authInstance.get(`/doctor/getDoctor?doctor_id=${doctorId}`);
};
export const listDoctorEffect = (payload) => {
  const { pageNo, pagesize, pagination_required, search, search_by } = payload;

  return authInstance.get(
    `/doctor/list?pageNo=${pageNo}&pagesize=${pagesize}&pagination_required=${pagination_required}&search_by=${search_by}&search=${search}`
  );
};

export const historyDoctorEffect = (pageNo) => {
  return authInstance.get(
    `/attenderbooking/getbysecirity?pageNo=${pageNo}&pagesize=10`
  );
};
